
import 'picturefill';

import './components/components.parallax';
import './components/components.scroll-to';
import './components/components.fade-up';